<template>
<div>

    <el-crud :baseUrl="'/devices'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        :filters="filters"
        @itemsFetched="handleItemsFetched"
        ref="crud">

        <template slot="crudFiltersDescription">
            <div v-if="filters.filter">Dispositivo: <strong>{{filters.filter}}</strong></div>
            <div v-if="!areFilters"><strong>Datos sin filtrar</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Dispositivo" label-width="120px" prop="filter">
                        <el-input placeholder="ID, nombre o dirección" v-model="filters.filter" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>

        <template slot="tableActions">
            <a slot="top-buttons" class="btn btn-default btn-sm" @click="statusCheck()"><i class="fa fa-download"></i> Verificar estado</a>
        </template>

        <template slot="table">
            <el-table-column
                prop="id"
                label="Id"
                width="50">
            </el-table-column>
            <el-table-column
                prop="name"
                label="Nombre"
                width="200">
            </el-table-column>
            <el-table-column
                label="CeCo">
                <template slot-scope="scope">
                    {{scope.row.cost_centers[0] && scope.row.cost_centers[0].description}}
                </template>
            </el-table-column>
            <el-table-column
                prop="type"
                label="Tipo">
            </el-table-column>
            <el-table-column
                prop="address"
                label="Dirección">
            </el-table-column>
            <!-- <el-table-column
                prop="status"
                label="Estado">
            </el-table-column> -->
            <el-table-column
                label="Enrolador">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_default_for_enrollment"
                    on-text="SI"
                    off-text="NO"
                    @change="handleDefaultForEnrollmentChange(scope.row.id)">
                    </el-switch>
                </template>
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Id" label-width="120px" :prop="resource.id.value" :error="scope.errors.id">
                <el-input v-model="resource.id.value" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Nombre" label-width="120px" :prop="resource.name" :error="scope.errors.name">
                <el-input v-model="resource.name" auto-complete="off" size="mini"></el-input>
            </el-form-item>


            <!-- <el-form-item label="Centro de Costo" label-width="120px" :prop="resource.profile" :error="scope.errors.cost_center_id">
                <el-select v-model="resource.cost_center_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in cost_centers"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item> -->

            <el-form-item label="Centro de Costo" label-width="120px" :prop="resource.cost_center_id" :error="scope.errors.cost_center_id">
                <div v-if="resource.edit_cost_center" style="border: 1px solid #aaa; padding: 10px 10px 10px 0">
                    <el-button icon="el-icon-close" size="mini" style="position: absolute;right: 5px;top: 5px;z-index: 99;" @click="handleCloseCostCenterForm()"></el-button>
                    <el-form-item label="CeCo" label-width="100px" :error="scope.errors.functionalArea">
                        <el-select v-model="resource.cost_center_id" filterable placeholder="Seleccione" size="mini" style="margin-bottom: 10px;">
                            <el-option
                                v-for="item in cost_centers"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Fechas" label-width="100px">
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.cost_center_date_from"
                                type="date"
                                style="width: 100%;"
                                placeholder="Desde" size="mini">
                            </el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.cost_center_date_to"
                                type="date"
                                style="width: 100%;"
                                placeholder="Hasta" size="mini">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                </div>
                <el-button v-else icon="el-icon-plus" size="mini" @click="resource.edit_cost_center = true">Centro de Costo</el-button>

                <ul v-if="resource.cost_centers !== null && resource.cost_centers.length > 0">
                    <li v-for="item in resource.cost_centers" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
            </el-form-item>


            <el-form-item label="Tipo" label-width="120px" :prop="resource.type" :error="scope.errors.type">
                <el-select v-model="resource.type" auto-complete="off" size="mini" placeholder="Seleccionar">
                    <el-option key="ZKTecoFacial" value="ZKTecoFacial" label="ZCTeco Reconocimiento Facial"></el-option>
                    <el-option key="MobileApp" value="MobileApp" label="Aplicación Móvil"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Dirección" label-width="120px" :prop="resource.address" :error="scope.errors.address">
                <el-input v-model="resource.address" auto-complete="off" size="mini"></el-input>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Dispositivo',
                    EditItemTitle: 'Editar Dispositivo',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el dispositivo. Desea continuar?'
                },
                filters: {
                    filter: null,
                },
                resource:{
                    id: {
                        value: null,
                        setValue: (value) => {
                            this.resource.id.value = (value != null) ? value.id.toString() : null;
                        },
                    },
                    name: null,
                    edit_cost_center: false,
                    cost_centers: null,
                    cost_center_id: null,
                    cost_center_date_from: null,
                    cost_center_date_to: null,
                    type: null,
                    address: null,
                },
            }
        },
        computed: {
            ...mapGetters(["cost_centers"]),
            'areFilters': function () {
                return this.filters.filter != null;
            }
        },
        components: {
            'el-crud': el_crud,
        },
        mounted() {
            this.fetchCostCenters();
        },
        methods: {
            ...mapActions(["fetchCostCenters"]),
            handleConnect() {
                axios.put('/api/devices/status', {connect: 'all'}).then((response) => {
                    console.log(response);
                });
            },
            handleDefaultForEnrollmentChange(deviceId) {
                axios.put('/api/devices/defaultforenrollment', {id: deviceId}).then((response) => {
                    console.log(response);
                    this.$refs['crud'].$refs['dataTable'].fetchItems();
                });
            },
            handleItemsFetched() {
                _.each(this.$refs['crud'].$refs['dataTable'].data, (item) => {
                    item.is_default_for_enrollment = item.is_default_for_enrollment == 1;
                });
            },
            handleCloseCostCenterForm () {
                this.resource.edit_cost_center = false;
                this.resource.cost_center_id = null;
                this.resource.cost_center_date_from = null;
                this.resource.cost_center_date_to = null;
            },
            statusCheck() {
                axios.get('/api/devices/status', {connect: 'all'}).then((response) => {
                    console.log(response);
                });
            }
        }
    }
</script>
